module.exports = __webpack_public_path__ + "static/media/15.6d3dc546.webp";